import { describeError } from '@gymcoach/shared';
import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query defaults for the CRM.
 *
 * Retrying a refusal (P0001), a "not allowed" or a "not found" gets the same answer, so
 * only transient failures (network, unknown) are retried, at most twice.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // One quick retry only: a basement with no signal should show the offline state in
        // about a second, not after ~25 s of stacked retries.
        retry: (failureCount, error) => failureCount < 1 && describeError(error).retryable,
        retryDelay: 800,
        refetchOnWindowFocus: true,
      },
      mutations: {
        retry: false,
      },
    },
  });
}

/**
 * Query keys. One factory so invalidation is predictable: invalidate `qk.gym()` and
 * every gym-scoped query refetches. Areas add their own keys under their own prefix,
 * e.g. ['clients', 'list', filters] in routes/clients/.
 */
export const qk = {
  me: (userId: string | null) => ['me', userId] as const,
  gym: () => ['gym'] as const,
};
